import { UPLOAD_IMAGE_URL, UPLOAD_ERROR, UPLOAD_IMAGE_DIMENSIONS, EXPERIMENT_DATA } from '../constants/actionTypes';

export default function update(state = {}, action) {
  if (action.type === UPLOAD_IMAGE_URL) {
    return Object.assign({}, state, { imageUrl: action.imageUrl });
  } else if (action.type === UPLOAD_ERROR) {
    return Object.assign({}, state, { errorCode: action.errorCode });
  } else if (action.type === UPLOAD_IMAGE_DIMENSIONS) {
    return Object.assign({}, state, { imageDimensions: action.value });
  } else if (action.type === EXPERIMENT_DATA) {
    return Object.assign({}, state, { experimentData: action.experimentData });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/upload.js